import { createContext, useContext } from 'react';
import bakedContent from '../data/cms-content.json';

// Default content is the build-time baked snapshot (src/data/cms-content.json),
// refreshed from Payload CMS by scripts/sync-payload.js before each dev/build.
// The public site reads components synchronously from the default value.
export const ContentContext = createContext(bakedContent);

export function useContent() {
  return useContext(ContentContext);
}

export { bakedContent };
